import React from 'react';

// tslint:disable max-line-length
const ROutroLocalMuseumTranscriptMunch: React.FC = () => (
  <>
    <h5>Postscript</h5>
    <p>Hey. I wonder...did the gift surprise you, or did you know these objects already?... Objects in a museum,...not owned, but given. Now you've had this gift from the museum, maybe you'll make a gift for someone you care about?</p>
  </>
);

export {
  ROutroLocalMuseumTranscriptMunch,
};
